import { formatMoney } from "@api/money";
import Cart from "@api/types/cart";
import { FC, Fragment, PropsWithChildren } from "react";

import CartGiftSelector from "@components/CartGiftSelector";
import CartQuantityPicker from "@components/CartQuantityPicker";
import Center from "@components/Center";
import LinkButton from "@components/LinkButton/LinkButton";
import Spacer from "@components/Spacer";

const CartPopulated: FC<PropsWithChildren<{ cart: Cart }>> = ({ cart }) => {
  if (!cart.items.length) {
    return <Center cy="empty-cart">Your cart is empty.</Center>;
  }

  return (
    <>
      <div className="CartPopulated">
        <div className="header" />
        <div className="header">Product / Part / Type</div>
        <div className="header">Price</div>
        <div className="header">Quantity</div>
        {cart.items.map((item, index) => {
          return (
            <Fragment key={item.id}>
              <div>
                <img src={item.product.thumbnail.src} alt="" />
              </div>
              <div className="detail">
                <div className="entry">{item.product.title}</div>
                <div className="entry">{item.product.mpn}</div>
              </div>
              <div className="detail">{formatMoney(item.price)}</div>
              <div className="detail">
                <CartQuantityPicker item={item} />
                <Spacer size={"sm"} />
                <CartGiftSelector item={item} />
              </div>
            </Fragment>
          );
        })}
      </div>
      <Spacer size="md" />
      <div className="CartTotal">
        <div className="orderTotal">Total</div>
        <div className="orderValue" data-cy="sub-total" data-value={cart.totals.subTotal.units}>
          {formatMoney(cart.totals.subTotal)}
        </div>
      </div>
      <Spacer size="md" />
      <div className="Actions">
        <div className="checkout">
          <LinkButton href={`/checkout`}>Checkout Now</LinkButton>
        </div>
      </div>
      {/* language=CSS */}
      <style jsx>
        {`
          .CartPopulated {
            display: grid;
            grid-template-columns: 2fr 6fr 2fr 2fr;
            grid-row-gap: 10px;
          }

          .header {
            background-color: rgb(255, 54, 0);
            color: white;
            padding: 4px 10px;
          }

          .entry {
            margin: 0 0 10px 0;
          }

          .detail {
            padding: 0 10px;
          }

          img {
            max-width: 100%;
            width: 100%;
          }

          .CartTotal {
            display: grid;
            grid-template-columns: 10fr 1fr 1fr;
            grid-row-gap: 10px;
          }

          .CartTotal .orderTotal {
            grid-column: 2;
          }

          .CartTotal .orderValue {
            text-align: right;
          }

          .Actions {
            display: grid;
            grid-template-columns: 1fr 3fr 1fr 1fr;
            grid-row-gap: 10px;
          }

          .Actions .checkout {
            grid-column: 4;
          }
        `}
      </style>
    </>
  );
};

export default CartPopulated;
